import { Navigate } from 'react-router-dom';

function getTechnicianRedirect(status) {
  if (status === 'approved') return '/technician/dashboard';
  if (status === 'denied') return '/technician/denied';
  return '/technician/pending';
}

function ProtectedRoute({ children, requiredRole, requiredStatus }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user'));

  if (!token) {
    // Not logged in → redirect to role selection
    return <Navigate to="/select-role" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    // Logged in but wrong role – redirect to their own dashboard
    if (user?.role === 'technician') {
      return <Navigate to={getTechnicianRedirect(user?.status)} replace />;
    } else if (user?.role === 'hirer') {
      return <Navigate to="/hirer/dashboard" replace />;
    } else if (user?.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else {
      return <Navigate to="/" replace />;
    }
  }

  // Technician dashboard requires approved status
  if (requiredStatus === 'approved' && user?.role === 'technician' && user?.status !== 'approved') {
    return <Navigate to={getTechnicianRedirect(user?.status)} replace />;
  }

  return children;
}

export default ProtectedRoute;